import React from 'react';

const ActivityFormPage = React.lazy(() => import('../pages/contents/ActivityFormPage/ActivityFormPage'));
const ContentCreatePage = React.lazy(() => import('../pages/contents/ContentCreatePage/ContentCreatePage'));
const ContentDetailPage = React.lazy(() => import('../pages/contents/ContentDetailPage/ContentDetailPage'));
const ContentsPage = React.lazy(() => import('../pages/contents/ContentsPage/ContentsPage'));
const ContentBatchUploadPage = React.lazy(() => import('../pages/contents/ContentBatchUpload/ContentBatchUploadPage'));
const ContentsActivitiesPage = React.lazy(() => import('../pages/contents/ContentsActivitiesPage/ContentsActivitiesPage'));
const ContentsActivityDetailPage = React.lazy(() => import('../pages/contents/ContentsActivityDetailPage'));

export const PATH_CONTENT = '/content/:guid/:step?';
export const PATH_CONTENTS = '/contents';
export const PATH_CONTENTS_ACTIVITIES = '/contents/activities';
export const PATH_ACTIVITY_CREATE = '/contents/activities/create';
export const PATH_CONTENTS_ACTIVITY_DETAIL = '/contents/activities/:guid/:step?';
export const PATH_CONTENT_CREATE = '/contents/create';
export const PATH_CONTENT_BATCH_UPLOAD = '/contents/batch-upload';

const PAGE_CONTENT = {
  component: ContentDetailPage,
  path: PATH_CONTENT,
};

const PAGE_CONTENTS = {
  component: ContentsPage,
  path: PATH_CONTENTS,
};

const PAGE_ACTIVITY_CREATE = {
  component: ActivityFormPage,
  path: PATH_ACTIVITY_CREATE,
};

const PAGE_CONTENTS_ACTIVITIES = {
  component: ContentsActivitiesPage,
  path: PATH_CONTENTS_ACTIVITIES,
};

const PAGE_CONTENTS_ACTIVITY_DETAIL = {
  component: ContentsActivityDetailPage,
  path: PATH_CONTENTS_ACTIVITY_DETAIL,
};

const PAGE_CONTENT_CREATE = {
  component: ContentCreatePage,
  path: PATH_CONTENT_CREATE,
};

const PAGE_CONTENT_BATCH_UPLOAD = {
  component: ContentBatchUploadPage,
  path: PATH_CONTENT_BATCH_UPLOAD,
};

// IMPORTANT: The order in which the pages are added is important.
// More specific paths must come before generic ones because <Switch> in
// Routes.jsx renders <Route path> without `exact`, so the first prefix match wins.
export default [
  PAGE_ACTIVITY_CREATE,
  PAGE_CONTENTS_ACTIVITY_DETAIL,
  PAGE_CONTENTS_ACTIVITIES,
  PAGE_CONTENT_BATCH_UPLOAD,
  PAGE_CONTENT_CREATE,
  PAGE_CONTENT,
  PAGE_CONTENTS,
];
